module.exports = __webpack_public_path__ + "img/流体力学5_2.e6434d3f.jpg";